import React from "react";
import { Link } from "react-router-dom";
import logoImg from "../assets/logo.png"; 
import logoTg from "../assets/logotg.png"; 

export default function Logo({ link = "/home", onClick, type = "default" }) {
  // logo select karega type ke hisaab se
  const getLogo = () => {
    if (type === "tg") return logoTg;
    return logoImg;
  };

  return (
    <div className="logo">
      <Link to={link} onClick={onClick}>
        <img src={getLogo()} alt={type === "tg" ? "TG Logo" : "Logo"} />
      </Link>
    </div>
  );
}





